/**
 * Helper component for rendering radio inputs
 *
 * NOTE: To use -
 * <RadioInput
 *   label="Leaderboard Sort Order"
 *   options={[
 *     {val: 'descending', display: 'Sort Descending'},
 *     {val: 'ascending', display: 'Sort Ascending'},
 *   ]}
 *   name="sortOrder"
 *   value={item.sortOrder}
 *   change={handleChange}
 * />
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

const RadioInput = ({
  change
  , className
  , helpText
  , inline
  , label
  , name
  , options
  , value
}) => {
    const hasHtmlTags = (htmlString) => /<\/?[a-z][\s\S]*>/i.test(htmlString);
  return (
    <div className={`mb-4 text-left ${className}`}>
      <label className="text-sm" htmlFor={name}>{label}</label>
      <div className={`flex ${inline ? 'flex-row' : 'flex-col'}`}>
      {options.map((option, i) => (
        <div key={`${name}_radio_${i}`} className={`p-2 rounded-md flex items-center m-1 w-full ${option?.val?.toString() !== value?.toString() ? '' : 'font-bold'} ${option.className || ''}`}>
          <input
            className="h-5 w-5 rounded accent-indigo-600 flex-shrink-0"
            type="radio"
            name={name}
            value={option?.val?.toString()}
            onChange={change}
            checked={option?.val?.toString() === value?.toString()}
            disabled={option?.disabled}
          />
          <label
            htmlFor={name}
            className={`ml-4 text-lg inline-block${option?.addWFull ? ' w-full' : ''}`}
          >
            {option?.display}
          </label>
          {option?.helpText && (!hasHtmlTags(option.helpText) ? <small className="text-xs text-gray-500 ml-2"><em>{option?.helpText}</em></small> : <small className="text-xs text-gray-500 flex items-center" dangerouslySetInnerHTML={{__html: option.helpText}}></small>)}
        </div>
      ))}
      </div>
      {helpText && <small className="text-xs text-gray-500"><em>{helpText}</em></small>}
    </div>
  )
}

RadioInput.propTypes = {
  change: PropTypes.func.isRequired
  , className: PropTypes.string
  , helpText: PropTypes.any
  , label: PropTypes.string
  , name: PropTypes.string.isRequired
  , options: PropTypes.arrayOf(
    PropTypes.shape({
      val: PropTypes.oneOfType([
        PropTypes.string
        , PropTypes.number
        , PropTypes.bool
      ]).isRequired
      , display: PropTypes.oneOfType([
        PropTypes.string
        , PropTypes.number
        , PropTypes.any
      ]).isRequired
    })).isRequired
  , value: PropTypes.any
}

RadioInput.defaultProps = {
  helpText: null
  , label: ''
}

export default RadioInput;
